__turbopack_context__.v({
  "container": "x0saKq_container",
  "graphic": "x0saKq_graphic",
  "isNavOpen": "x0saKq_isNavOpen",
});
